import { Link } from 'react-router-dom';

const footerLinks = {
  pages: [
    { label: '首页', path: '/' },
    { label: '关于我们', path: '/about' },
    { label: '核心业务', path: '/business' },
    { label: '蚂蚁量化', path: '/quant' },
    { label: '产品下载', path: '/downloads' },
    { label: '合作平台', path: '/cooperation' },
    { label: '新闻动态', path: '/news' },
    { label: '联系我们', path: '/contact' },
  ],
  business: [
    { label: '蚂蚁量化', path: '/quant' },
    { label: '蚂蚁基金', path: '/business' },
    { label: '蚂蚁家办', path: '/business' },
    { label: '蚂蚁资本', path: '/business' },
  ],
  legal: [
    { label: '隐私政策', path: '#' },
    { label: '合规声明', path: '#' },
    { label: '网站地图', path: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-50 border-t border-background-300/30">
      {/* Top accent line */}
      <div className="h-px bg-gradient-to-r from-transparent via-accent-500/30 to-transparent"></div>

      <div className="px-6 md:px-12 py-16 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-16">
            {/* Brand Column */}
            <div className="lg:col-span-5">
              <Link to="/" className="inline-block">
                <span className="text-3xl md:text-4xl font-bold font-heading text-accent-400 tracking-wide">
                  蚂蚁链控股集团
                </span>
              </Link>
              <p className="mt-6 text-sm leading-relaxed text-foreground-500 max-w-md">
                香港蚂蚁链控股集团立足香港国际金融中心，坚持合规治理、风险可控、专业研究，致力于为全球机构与高净值客户提供长期稳健的资产管理解决方案。投资有风险，过往业绩不预示未来表现。
              </p>
              <div className="flex items-center gap-4 mt-8">
                {['ri-linkedin-fill', 'ri-twitter-x-line', 'ri-wechat-line', 'ri-mail-line'].map((icon) => (
                  <a
                    key={icon}
                    href="#"
                    className="w-9 h-9 rounded-full border border-background-400/40 flex items-center justify-center text-foreground-500 hover:text-accent-400 hover:border-accent-500/40 transition-all duration-300"
                  >
                    <i className={`${icon} text-sm`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div className="lg:col-span-2">
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-500 mb-5">页面导航</h4>
              <ul className="space-y-3">
                {footerLinks.pages.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-accent-400 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Business Lines */}
            <div className="lg:col-span-2">
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-500 mb-5">核心业务</h4>
              <ul className="space-y-3">
                {footerLinks.business.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-accent-400 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="lg:col-span-3">
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-500 mb-5">联系我们</h4>
              <div className="space-y-5">
                <div>
                  <p className="text-xs text-foreground-600 mb-1">地址</p>
                  <p className="text-sm text-foreground-400 leading-relaxed">
                    香港中环金融街8号<br />国际金融中心二期
                  </p>
                </div>
                <div>
                  <p className="text-xs text-foreground-600 mb-1">电话</p>
                  <p className="text-sm text-foreground-400">+852 2801 6800</p>
                </div>
                <div>
                  <p className="text-xs text-foreground-600 mb-1">邮箱</p>
                  <p className="text-sm text-foreground-400">info@antchain-holdings.hk</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-background-300/30">
        <div className="px-6 md:px-12 py-5">
          <div className="max-w-[1400px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-600">
              &copy; {new Date().getFullYear()} 香港蚂蚁链控股集团 Ant Chain Holding Group. 保留所有权利。
            </p>
            <div className="flex items-center gap-6">
              {footerLinks.legal.map((link) => (
                <a
                  key={link.label}
                  href={link.path}
                  className="text-xs text-foreground-600 hover:text-accent-400 transition-colors duration-200"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}